import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LoginScreen } from "pages/auth/login/loginScreen";
import { ResetPasswordScreen } from "pages/auth/resetPassword/resetPasswordScreen";
import { PrivateRoutes } from "./privateRoutes";
import { PublicRoutes } from "./publicRoutes";
import { AdminRoutes } from "layouts/admin/adminRoutes";
import { SolicitudViolenciaScreen } from "pages/SolicitudViolencia/SolicitudViolenciaScreen";
import { useUiStore } from "hooks/useUiStore";
import { SiteUnderMaintenanceScreen } from "pages/siteUnderMaintenance/siteUnderMaintenanceScreen";
import SolicitudFirmasScreen from "pages/solicitudFirmas/solicitudFirmasScreen";
import { useAuthStore } from "hooks/useAuthStore";
import { Box } from "@mui/material";
import { Loading } from "components/ui/loading";
import { AnimatedBackground } from "components/ui/customComponents/animatedBackground";
import { FormScanQR } from "components/AccesosEdificios/scanQR/FormScanQR";
import { FormQrScanned } from "components/AccesosEdificios/QrScanned/FormQrScanned";
import { useGeneralStore } from "hooks/generalesStore";
import { PreguntasFrecuentes } from "components/preguntasFrecuentes/preguntas";
import { AuthLayout } from "layouts/auth/authLayout";
import { InscripcionCursosForm } from "components/inscripcionCursos/inscripcionCursosForm";
import { FormNormas } from "components/normatividad/formNormas";

export const AppRoutes = () => {
  const { handleChangeDarkMode, changeSiteMaintenance } = useUiStore();
  const { status, startGetUser } = useAuthStore();
  const { startGetVideoAyuda } = useGeneralStore();

  const url = window.location.search;
  const urlParams = new URLSearchParams(url);
  const paramInvitado = urlParams.get("key");

  useEffect(() => {
    if (localStorage.getItem("typeTheme")) {
      const theme = localStorage.getItem("typeTheme") || "";
      handleChangeDarkMode(
        theme === "dark" || theme === "light" ? theme : "light"
      );
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      process.env.REACT_APP_SITE_UNDER_MAINTENANCE === "true" &&
      localStorage.getItem("user") !== "9999999"
    ) {
      changeSiteMaintenance(true);
      localStorage.removeItem("lastpath");
      localStorage.removeItem("token");
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!paramInvitado) {
      console.log("!paramInvitado");

      startGetUser();
      startGetVideoAyuda();
    }
    //eslint-disable-next-line
  }, [paramInvitado]);

  if (status === "checking")
    return (
      <Box className="bg-[#b3b3b3b3] w-screen h-screen">
        <Loading />
        <AnimatedBackground />
      </Box>
    );
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="auth/*"
          element={
            <PublicRoutes>
              <Routes>
                <Route path="login" element={<LoginScreen />} />
                <Route
                  path="reset-password"
                  element={<ResetPasswordScreen />}
                />
                <Route
                  path="preguntas-frecuentes"
                  element={
                    <AuthLayout title="Preguntas Frecuentes">
                      <PreguntasFrecuentes origen={"login"} />
                    </AuthLayout>
                  }
                />
                <Route
                  path="inscripcion-Cursos"
                  element={
                    <AuthLayout title="Inscripción a Cursos">
                      <InscripcionCursosForm origen={"login"} />
                    </AuthLayout>
                  }
                />
                <Route
                  path="normatividad"
                  element={<FormNormas isNormas={true}/>}
                />
                <Route path="/*" element={<Navigate to="/auth/login" />} />
              </Routes>
            </PublicRoutes>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoutes>
              <AdminRoutes />
            </PrivateRoutes>
          }
        />
        <Route
          path="/solicitud-violencia"
          element={<SolicitudViolenciaScreen />}
        />
        <Route
          path="/sitio-en-mantenimiento"
          element={<SiteUnderMaintenanceScreen />}
        />

        <Route path="/solicitudes-firmas" element={<SolicitudFirmasScreen />} />
        {!window.location.host.includes(
          "tribunalelectronico.pjedomex.gob.mx"
        ) ? (
          <Route path="/scanner-qr" element={<FormScanQR />} />
        ) : null}
        {!window.location.host.includes(
          "tribunalelectronico.pjedomex.gob.mx"
        ) ? (
          <Route path="/qr-scanned/:cveQr" element={<FormQrScanned />} />
        ) : null}

        <Route
          path="/*"
          element={
            <Navigate
              to={
                paramInvitado
                  ? "solicitudes-firmas"
                  : process.env.REACT_APP_SITE_UNDER_MAINTENANCE === "false"
                  ? localStorage.getItem("lastpath") || "/dashboard/inicio"
                  : localStorage.getItem("lastpath") ||
                    "/sitio-en-mantenimiento"
              }
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
